import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

@Injectable()
export class UserStateService {
  private readonly apiPrefix = '/client/state';

  constructor(
    private apiService: ApiService
  ) {
  }

  getAllStates() {
    return this.apiService.get(`${this.apiPrefix}`);
  }

  upsertState(data: object) {
    return this.apiService.post(`${this.apiPrefix}`, data);
  }
}
